import React from "react";
import { Container } from "react-bootstrap";
import { AlphaSection } from "../../Components/AlphaSection";
import backtest_proxy from "assets/images/alpha/backtest_proxy.png";
import backtest_proxy_under_different_regimes from "assets/images/alpha/backtest_proxy_under_different_regimes.png";
import feature_importance_bar_chart from "assets/images/alpha/feature_importance_bar_chart.png";
import return_distibution from "assets/images/alpha/return_distibution.png";
import plot_seasonality_effect from "assets/images/alpha/plot_seasonality_effect.png";
import pie_chart_showing_win_prices from "assets/images/alpha/pie_chart_showing_win_prices.png";

export const Alpha = () => {
  let AlphaArr = [
    {
      title: "Backtest Proxy",
      description:
        "The backtest proxy will be an observation of the cumulative returns of the factor/alpha, compared to a buy and hold",
      points: [
        "Display Sharpe ratio",
        "Realized volatility of the alpha",
        "The max drawdown of the alpha",
        "Show performance of buy only",
      ],
      imgURL: backtest_proxy,
    },
    {
      title: "Backtest Proxy Under Different Regimes",
      points: [
        "Observation of the cumulative returns of the factor/alpha in different regimes.",
        "Regimes could be defined using:",
        {
          title: "Volatility",
          subpoints: [
            "Structural break stats",
            "Rolling correlation between volatility and momentum ",
          ],
        },
      ],
      imgURL: backtest_proxy_under_different_regimes,
      // imgURL: "assets/images/alpha/backtest_proxy_under_different_regimes.png",
    },
    {
      title: "Feature Importance Bar Chart",
      points: [
        "Bar chart showing relative importance of factor/alpha compared to other factors",
      ],
      imgURL: feature_importance_bar_chart,
      // imgURL: "assets/images/alpha/feature_importance_bar_chart.png",
    },
    {
      title: "Return Distribution",
      points: [
        "Plot return distribution",
        "Shapiro-Wilk and D’Agostino’s test to check for normality ",
        "Normality is often a desired characteristic of the return distribution, but rarely ever obtained.",
        {
          title: "The skew that the alpha/factor exhibits",
          subpoints: [
            "Traders need to be careful when trading alphas with negative skew; often, the trading strategies exhibit favorable return characteristics, but incur heavy, infrequent losses.",
          ],
        },
        {
          title: "Kurtosis, fatness of tails",
          subpoints: [
            "The fatness of tails also is an indication of how commonly the strategies encounter higher fluctuations in capital, and the trader need to be prepared for events like market stress and black swans.",
          ],
        },
      ],
      imgURL: return_distibution,
      // imgURL: "assets/images/alpha/return_distibution.png",
    },
    {
      title: "Plot Seasonality Effects",
      points: [
        "Heat map showing seasonality effects",
        "Average returns grouped by month",
        "Average returns grouped by day",
      ],
      imgURL: plot_seasonality_effect,
      // imgURL: "assets/images/alpha/plot_seasonality_effect.png",
    },
    {
      title: "Pie chart showing win rates",
      points: [
        "Daily win ratios",
        "Monthly win ratios",
        "Win rates should indicate how frequently the trader can expect to be in the green; even if the equity curve is exceptional, the strategy's day-to-day operations may not feel as encouraging.",
      ],
      imgURL: pie_chart_showing_win_prices,
      // imgURL: "assets/images/alpha/pie_chart_showing_win_prices.png",
    },
  ];
  return (
    <div>
      <Container>
        {AlphaArr.map((section, index) => {
          return <AlphaSection key={index} {...section} />;
        })}
      </Container>
    </div>
  );
};
